import { useServiceStore } from '@/contexts/service-context';
import { useAddToCartEvent } from '@/hooks/useAddToCartEvent';
import { useOptionChangeEvent } from '@/hooks/useOptionChangeEvent';

import { PdpWidgetInner } from './pdp-widget-inner';

export function PdpWidgetWrapper() {
  const { serviceContentById, services } = useServiceStore();

  useOptionChangeEvent();
  useAddToCartEvent();

  if (!services) return null;

  return (
    <div className="widget-group widget-group--pdp">
      {services.map((service) => {
        return (
          <PdpWidgetInner
            key={service.id}
            service={service}
            serviceContent={serviceContentById[service.id].content}
          />
        );
      })}
    </div>
  );
}
